module.exports = __webpack_public_path__ + "static/pragma-d8c738042f858bc20413a97b31451ab0.png";